import send from './index';

export default {
    // 获取系统配置
    getSysConfig(data: any = {}) {
        return send({
            url: '/member/getSysConfig',
            method: 'get',
            data,
        });
    },
    // 获取注册限制信息
    getRegIsShow(params: any = {}) {
        // return send({ params, url: '/member/getRegIsShow', method: 'get' });
        return send({ params, url: `/member/getRegIsShowV2/${params.channel}`, method: 'get' });
    },
    // 获取系统变化配置
    getConfigVersion(params = {}) {
        return send({ params, url: '/member/getConfigVersion' });
    },
    // 获取游戏缓存
    getGameVersion(data: any = {}) {
        return send({
            url: '/member/getGameVersion',
            method: 'get',
            data,
        });
    },
    // 新在线客服
    GetContactWayListPage(data = {}) {
        return send({ data, url: '/sys/contentWay/findEnabled', method: 'POST' });
    },

    // 侧边菜单客服接口
    getFindPromoEnabled(data = {}) {
        return send({ data, url: '/sys/contentWay/findPromoEnabled' });
    },

    // /withdraw/withdrawOrder/findList/20
    // 获取提现记录
    getWithdrawOrderList(data: any) {
        return send({ data, url: `/withdraw/withdrawOrder/findList/${data.rows}` });
    },

    // 获取提现记录
    getScrollNoticeList(data: any) {
        return send({ data, url: `/content/contentNotice/scrollNoticeList/${data.rows}` });
    },

    // 获取收藏和最近的列表
    findGameInfoList(data: any = {}) {
        return send({ data, url: '/game/findGameInfoList', method: 'POST' });
    },

    // /game/searchCompany 获取游戏公司列表
    searchCompany(data: any = {}) {
        return send({ data, url: '/game/searchCompany', method: 'POST' });
    },

    // /game/searchCompany 获取游戏公司列表
    searchCompanyV3(data: any = {}) {
        return send({ data, url: '/game/searchCompanyV3', method: 'POST' });
    },

    // /game/searchGames/ 获取游戏列表
    searchGames(data: any = {}) {
        return send({ data, url: `/game/searchGames/${data.pageIndex}/${data.limit}`, method: 'POST' });
    },

    // /game/searchGames/ 获取游戏列表
    searchGamesV3(data: any = {}) {
        return send({ data, url: `/game/searchGamesV3/${data.pageIndex}/${data.limit}`, method: 'POST' });
    },

    // 获取轮盘 根据sn获取轮盘
    findUserRoulette(data: any = {}) {
        return send({
            data,
            url: data?.sn ? `/roulette/findRoulette/${data?.sn}` : '/roulette/findUserRoulette',
            method: 'POST',
        });
    },

    // 获取轮盘提现记录
    rouletteWithdraw(data: any = {}) {
        return send({ data, url: '/roulette/rouletteWithdraw', method: 'POST' });
    },

    // 旋转轮盘
    rouletteUserDraw(data: any = {}) {
        return send({ data, url: '/roulette/userDraw', method: 'POST' });
    },

    // 获取轮盘提现记录
    findUserRouletteRecord(data: any = {}) {
        return send({ data, url: `/roulette/findRouletteRecords/${data?.sn}/${data?.period}` });
    },
    // 获取轮盘详情提现记录
    findUserRouletteMemberFlow(data: any = {}) {
        return send({ data, url: `/member/memberFlow/findPage/${data?.current}/${data?.size}`, method: 'POST' });
    },

    getPromotionTemplate(data: any) {
        return send({
            url: `/promotion/promotionTemplate/findDetail/${data.id}`,
            method: 'get',
        });
    },

    // 网站公告全部已读
    messageReadAll(data: any = {}) {
        return send({ data, url: `/content/contentNotice/readAll`, method: 'POST' });
    },
    // 消息删除全部已读
    deleteAllRead(data: any = {}) {
        return send({ data, url: `/content/contentNotice/deleteAllRead`, method: 'POST' });
    },
    // 消息删除全部已读
    deleteReadId(data: any = {}) {
        return send({ data, url: `/member/memberUserMessage/delete/${data?.id}` });
    },
    // 消息id已读
    readMessageId(data: any = {}) {
        return send({ data, url: `/content/contentNotice/read/${data?.type}/${data?.id}`, method: 'POST' });
    },
    // 获取消息列表
    findMessageList(data: any = {}) {
        return send({ data, url: `/content/contentNotice/findList/${data?.page}/${data?.size}` });
    },
    // 获取菜单列表
    findMenuList(data: any = {}) {
        return send({ data, url: `/content/activity/findMenu` });
    },
    // 发送标记埋点是否成功 /delAfMessage/{id}
    delAfMessage(data: any = {}) {
        return send({ data, url: `/member/delAfMessage/${data?.id}`, method: 'POST' });
    },
    getTimeStamp(data: any = {}) {
        return send({ data, url: `/sys/sysLanguage/getTimeStamp` });
    },
    shareMemberAccount(data: any = {}) {
        return send({ data, url: `/member/memberShareAccount/share`, method: 'POST' });
    },
    // 根据渠道获取安卓apk下载地址
    getPromotionTemplateChannel(data: any) {
        return send({
            url: `/promotion/promotionTemplate/findChannel/${data.id}`,
            method: 'get',
        });
    },

    // 切换语言
    switchLanguage(data: any) {
        return send({
            url: `/member/switchLanguage`,
            method: 'post',
        });
    },
};
